import styled from 'styled-components';

export const TableStyled = styled.div`
  width: 100%;
  height: 400px;
  background-color: #fff;
  margin-top: 20px;
`;